/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAuthUserRegisterInput } from "../../entities/models/AuthUserRegisterInput";
import { z } from "zod/v4";

export const modelsAuthUserRegisterInputSchema = z.object({
    "email": z.optional(z.string()),
"name": z.optional(z.string()),
"password": z.string(),
"phone_number": z.string()
    }) as unknown as z.ZodType<ModelsAuthUserRegisterInput>